import { useEffect, useState } from 'react'
import './DeComandat.css'

const API_BASE = 'https://dyt8xo9cba.execute-api.eu-central-1.amazonaws.com/techStage/'

function DeComandat() {
    const [suppliers, setSuppliers] = useState([])
    const [loading, setLoading] = useState(true)
    const [error, setError] = useState('')

    useEffect(() => {
        getDeComandat()
    }, [])

    async function getDeComandat() {
        try {
            setLoading(true)
            setError('')

            const token = localStorage.getItem('techdelivery_token')

            const response = await fetch(`${API_BASE}/getDeComandat`, {
                headers: {
                    Authorization: `Bearer ${token}`
                }
            })

            const data = await response.json()

            if (!response.ok) {
                throw new Error(data.message || 'Eroare la încărcare.')
            }

            setSuppliers(data.suppliers || [])
        } catch (error) {
            setError(error.message)
        } finally {
            setLoading(false)
        }
    } function getSlug(name) {
        return String(name || '')
            .trim()
            .replace(/\s+/g, '-')
    }

    return (
        <div className="deComandatPage">
            <div className="deComandatTop">
                <div>
                    <h1>Comandă furnizor</h1>
                    <p>Produse acceptate de client, grupate pe furnizor.</p>
                </div>

                <button type="button" onClick={getDeComandat}>
                    Actualizează
                </button>
            </div>

            {loading && (
                <div className="deComandatState">
                    Se încarcă produsele...
                </div>
            )}

            {!loading && error && (
                <div className="deComandatError">
                    {error}
                </div>
            )}

            {!loading && !error && suppliers.length === 0 && (
                <div className="deComandatState">
                    Nu există produse acceptate de comandat.
                </div>
            )}

            {!loading && !error && suppliers.map((supplier) => (
                <section className="supplierOrderCard" key={supplier.id}>
                    <div className="supplierOrderHeader">
                        <div className="supplierOrderIdentity">
                            {supplier.logo && (
                                <img src={supplier.logo} alt="" />
                            )}

                            <div>
                                <h2>{supplier.nume}</h2>
                                <span>{supplier.totalProduse} produse de comandat</span>
                            </div>
                        </div>


                    </div>

                    <div className="supplierOrderTable">
                        <div className="supplierOrderRow supplierOrderHead">
                            <span>Produs</span>
                            <span>Cod</span>
                            <span>EAN</span>
                            <span>Cantitate</span>
                            <span>Link</span>
                        </div>

                     {supplier.produse.map((product) => (
  <div className="supplierOrderItem" key={product.key}>
    <div className="supplierOrderMainRow">
      <div className="supplierOrderProductName">
        <strong>{product.nume}</strong>
      </div>

      <span>{product.cod_produs || '-'}</span>
      <span>{product.ean || '-'}</span>

      <strong className="supplierOrderQty">
        {product.cantitate}
      </strong>

      <span>
        {product.link_produs ? (
          <a
            href={product.link_produs}
            target="_blank"
            rel="noreferrer"
            className="productLinkButton"
          >
            Vezi produs

            <svg
              viewBox="0 0 24 24"
              width="14"
              height="14"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
            >
              <path d="M14 3h7v7" />
              <path d="M10 14L21 3" />
              <path d="M21 14v4a3 3 0 0 1-3 3H6a3 3 0 0 1-3-3V6a3 3 0 0 1 3-3h4" />
            </svg>
          </a>
        ) : (
          '-'
        )}
      </span>
    </div>

    <div className="supplierOrderDetailsRows">
      {product.comenzi.map((order) => (
        <div
          className="supplierOrderDetailsRow"
          key={`${order.uuid}-${order.cantitate}`}
        >
          <span>
            {order.client_nume} ·{' '}
            <a href={`/clienti/${getSlug(order.client_nume)}/${order.uuid}`}>
              {order.nume_comanda}
            </a>
          </span>

          <span className="supplierOrderDetailsQty">
            {order.cantitate}
          </span>
        </div>
      ))}
    </div>
  </div>
))}
                    </div>
                </section>
            ))}
        </div>
    )
}

export default DeComandat